import React from 'react'

import {
  ButtonClean,
  Dropdown,
  Icon,
  ToolbarButton,
  Tooltip,
  useCopyToClipboard,
} from '@fourthwall/components'
import { DotsHorizontalIcon, DuplicateIcon, TickIcon } from '@fourthwall/icons'

import * as S from './PublicTokenListItem.styled'

type PublicTokenListItemProps = {
  token: string
  onDelete: (token: string) => void
}

export const PublicTokenListItem = ({ token, onDelete }: PublicTokenListItemProps) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard()

  return (
    <S.Container>
      <S.TokenContainer>
        <div>{token}</div>
        <div>
          {isCopied ? (
            <Tooltip reference={<Icon component={TickIcon} height={12} />}>Copied!</Tooltip>
          ) : (
            <Tooltip
              reference={
                <ButtonClean label="" icon={DuplicateIcon} onClick={() => copyToClipboard(token)} />
              }
            >
              Copy
            </Tooltip>
          )}
        </div>
      </S.TokenContainer>
      <Dropdown
        content={<Dropdown.Item label="Remove" onClick={() => onDelete(token)} />}
        position="bottom-end"
      >
        <ToolbarButton icon={DotsHorizontalIcon} />
      </Dropdown>
    </S.Container>
  )
}
